export default __webpack_public_path__ + "static/media/herbalalerya_logo.7f08a133.png";